<template>  
    <section :style="{ height: wrapperHeight + 'px' }" class="list sale">
		<div class="tabs">
			<span :class='selectFlag?"select-flag":""' @click='changeNews("1")'>收支明细</span>
			<span :class='selectFlag?"":"select-flag"' @click='changeNews("2")'>提现记录</span>
		</div>
		
		<mt-loadmore v-if="balanceList && balanceList.length" :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore" :bottomPullText='"加载更多"' :bottomLoadingText='"加载中"' :bottomDropText='"释放加载"'>
			<ul>
				<li class="news-wrap" v-for="(item,index) of balanceList" :key="index" @click="toBalanceDetail(item)">
					<div class="balance-money">
						<span class="text" v-if="type==1 && item.order_code!=null">{{item.describe}}<span class="order-note">&nbsp;(订单:{{item.order_code}})</span></span>
						<span class="text" v-if="type==1 && item.order_code==null">{{item.describe}}</span>
						<span class="text" v-if="type==2">{{item.withName}}</span>
						
						<span class="time">{{item.create_time}}</span>
					</div>
					
					<div class="balance-money">
						<span class="balance">余额：<span class="balance">{{item.now_balance}}</span></span>
						<span class="count-money">
							<span class="money" v-if="type==1" v-text='item.type == "1"?"+":"-"'></span>
							<span class="money" v-if="type==2" v-text='item.status == "3"?"+":"-"'></span>
							<span class="money">{{ item.amount }}</span>
						</span>
					</div>
				</li>
			</ul>
		</mt-loadmore>
		<div v-else>
			<div class="no-order">
				<img src="../../assets/images/no-detail.png">
				<p v-if='type==1'>暂无收支明细</p>
				<p v-if='type==2'>暂无提现记录</p>
			</div>
		</div>
    </section>
</template>
<script>
import CommonHeader from '@/components/CommonHeader'
import { getBalanceRecord,gertUserWithdrawal } from '@/api/wallet'  
import utils from '@/assets/jslibs/utils'
export default {
	name: 'Balance',
	components: {
		CommonHeader
	},
	
	data() {
		return {
			wrapperHeight:0,
			allLoaded:false,
			type:"1",
			selectFlag:true,
			balanceList: [],
			body: {
				page_index: 1,
				page_size: 25,
			},
			
			paramas: {
				page_index: 1,
				page_size: 25,
			},
		}
	},
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
	
	created() {
		this.getBalanceList();
	},
	
	mounted(){
	    this.wrapperHeight = document.documentElement.clientHeight;
        document.title = "余额明细"
	},
	
	methods: {
		async getBalanceList() {
			const { data, status } = await getBalanceRecord(this.body);
			if( status !== 200) return
			this.balanceList = data.data;
			if(data.data.length){
			    this.body.page_index += 1;
			}
		},
		
		//提现记录
		async gertUserWithdrawal(){
			const { data, status } = await gertUserWithdrawal(this.paramas);
			if( status !== 200) return
			this.balanceList = data.data;
			this.balanceList.forEach((item,index)=>{
				item.withName = utils.statusToType(item.status)
			})
			if(data.data.length){
			    this.paramas.page_index += 1;
			}
		},
		
		loadBottom(){
		    this.$refs.loadmore.onBottomLoaded();
		    this.$refs.loadmore.onTopLoaded();
			if(this.type=="1"){
				this.loadMoreRecord()
			}else if(this.type=="2"){
				this.loadMoreWithdrawal()
			}
		    
		},
		
		async loadMoreRecord(){
		    const { data, status } = await getBalanceRecord(this.body);
		    if( status !== 200) return
		    if(data.data.length){
		        this.body.page_index += 1
		        this.balanceList = this.balanceList.concat(data.data);
		    }else{
		        window.toast("没有更多数据","txt");
		    }
		},
		
		async loadMoreWithdrawal(){
		    const { data, status } = await gertUserWithdrawal(this.paramas);
		    if( status !== 200) return
		    if(data.data.length){
		        this.paramas.page_index += 1
		        this.balanceList = this.balanceList.concat(data.data);
				this.balanceList.forEach((item,index)=>{
					item.withName = utils.statusToType(item.status)
				})
		    }else{
		        window.toast("没有更多数据","txt");
		    }
		},
		
		toBalanceDetail(item) {
			this.$router.push({
				path: '/balancedetail-sale',
				query: {type:this.type}
			})
			sessionStorage.setItem("balance",JSON.stringify(item))
		},
		
		// 切换类型
		changeNews(type){
			this.type = type;				//判断是	收支明细还是体现记录
			this.selectFlag=!this.selectFlag;
			this.balanceList =[];
			this.paramas.page_index = 1;
			this.body.page_index = 1;
			if(type=="1"){//查看收支明细
				this.getBalanceList();
			}else if(type==2){//查看提现记录
				this.gertUserWithdrawal()
			}
		},
	}
}
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';
    section{font-family:PingFangSC-Regular;font-weight:400;background: #fff}
	.no-order{width: 85px;height:78.5px;margin: 0 auto;margin-top:50%;margin-bottom: 50%}
	.no-order img{width: 100%;height: 100%}
	.no-order p{text-align: center;font-size:13px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(207,207,207,1);line-height:18.5px;margin-top: 10.5px}
	.list{overflow-y: scroll; width: 100%;height: 100%;};
	.news-wrap{border-bottom: 1px solid #EEEEEE;padding: 13px 20px 13px 20px;}
	.balance-money{display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center}
	.text{font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);font-size: 15px}
	.time{color:rgba(153,153,153,1);font-size: 13px;float: right;}
	.balance{color:rgba(51,51,51,1);font-size: 13px}
	.order-note{color:rgba(51,51,51,1);font-size: 12px}
	.count-money{display: flex;align-items: center;}
	.money{font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);font-size: 19px;}
	.tabs{height: 44px;border-bottom: 1px solid #EEEEEE;padding: 0 68px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center}
	.tabs span{color:rgba(51,51,51,1);font-size: 16px;height: 44px;line-height: 44px;}
	.select-flag{color:rgba(65,132,244,1);border-bottom: 2px solid #4184F4;font-family:PingFangSC-Medium;font-weight:500;}
</style>
